import { Card, CardBody } from '../ui/Card.js';
import { Logo } from '../ui/Logo.js';
import { useModulePermission } from '../lib/auth-context.js';

const LABELS: Record<string, string> = {
  pricing: 'Pricing',
  accounting: 'Accounting',
  call_reports: 'Call Reports',
  reporting: 'Reporting',
  crm: 'CRM',
  admin_tasks: 'Admin Tasks',
};

const DESCRIPTIONS: Record<string, string> = {
  pricing: 'Live UWM Easy Qualifier pricing matrices, scenarios, and lock workflow.',
  accounting: 'MCR-ready ledger, commissions, P&L by branch, integrations with QuickBooks/Xero.',
  call_reports: 'NMLS-friendly call report exports and quarterly state filings.',
  reporting: 'Pipeline, conversion, and team-performance dashboards.',
  crm: 'Borrower lifecycle, drip campaigns, post-close anniversary touches.',
  admin_tasks: 'Onboarding, license tracking, document expirations, audit handoffs.',
};

export function PlaceholderPage({ moduleKey }: { moduleKey: string }) {
  const perm = useModulePermission(moduleKey);
  const label = LABELS[moduleKey] ?? moduleKey;

  return (
    <div className="mx-auto max-w-2xl space-y-4">
      <Card>
        <CardBody className="flex flex-col items-center gap-5 px-8 py-12 text-center">
          <Logo variant="emblem" tone="light" size={56} />
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-gold-700">
            Coming in a future phase
          </p>
          <h1 className="font-display text-3xl font-bold text-brand-navy-800">{label}</h1>
          <p className="max-w-md text-sm leading-relaxed text-slate-600">
            {DESCRIPTIONS[moduleKey] ?? 'This module will be enabled in a future phase.'}
          </p>
          <div className="grid w-full max-w-sm grid-cols-3 gap-2 text-xs">
            <PermPill label="View" on={perm.canView} />
            <PermPill label="Edit" on={perm.canEdit} />
            <PermPill label="Admin" on={perm.canAdmin} />
          </div>
          <p className="text-[11px] text-slate-400">
            Phase 1 ships Pipeline Tracking and Workflows. Access control for every module is already enforced.
          </p>
        </CardBody>
      </Card>
    </div>
  );
}

function PermPill({ label, on }: { label: string; on: boolean }) {
  return (
    <div
      className={`rounded-lg border px-2 py-1 text-center ${
        on
          ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
          : 'border-slate-200 bg-slate-50 text-slate-400'
      }`}
    >
      {label}: {on ? 'yes' : 'no'}
    </div>
  );
}
